import { FormConfig } from '../edit-create-form.interfaces';

export const updateTrackerAssignmentFormConfig = (): FormConfig => {
    return {
        fields: [
            {
                key: 'id',
                label: 'ID',
                type: 'text',
                width: 'full',
                hidden: true
            },
            {
                key: 'gvTaInfo',
                label: 'GV/TA',
                labelPosition: 'inline',
                width: 'full',
                type: 'static',
                value: (data: any) => `${data.gvTaEmployeePosition?.employee?.code || 'N/A'} - ${data.gvTaEmployeePosition?.employee?.name || 'N/A'} (${data.gvTaEmployeePosition?.position?.name || 'N/A'})`
            },
            {
                key: 'trackerInfo',
                label: 'Tracker',
                labelPosition: 'inline',
                width: 'full',
                type: 'static',
                value: (data: any) => `${data.trackerEmployeePosition?.employee?.code || 'N/A'} - ${data.trackerEmployeePosition?.employee?.name || 'N/A'} (${data.trackerEmployeePosition?.position?.name || 'N/A'})`
            },
            {
                key: 'fromDate',
                label: 'Ngày bắt đầu',
                required: true,
                width: 'half',
                type: 'datepicker',
                placeholder: 'Chọn ngày bắt đầu',
                customErrorMessage: 'Vui lòng chọn ngày bắt đầu'
            },
            {
                key: 'toDate',
                label: 'Ngày kết thúc',
                required: false,
                width: 'half',
                type: 'datepicker',
                placeholder: 'Chọn ngày kết thúc (tùy chọn)'
            }
        ]
    };
};

